<p-table [value]="items()" size="small" [rowHover]="true" (onSort)="sort($event)" [lazy]="true" [sortField]="sorting().orderByClause" [sortOrder]="sorting().orderDirection === 'asc' ? 1 : -1">
    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="code" >Codice <p-sortIcon field="code" /></th>
            <th pSortableColumn="short_description" >Titolo <p-sortIcon field="short_description" /></th>
            <th pSortableColumn="client_short_description">Cliente <p-sortIcon field="client_short_description" /></th>
            <th pSortableColumn="reference">Referente <p-sortIcon field="reference" /></th>
            <th pSortableColumn="request_date">Data Richiesta <p-sortIcon field="request_date" /></th>
            <th pSortableColumn="expire_date">Data scadenza <p-sortIcon field="expire_date" /></th>
            <th pSortableColumn="state_id">Stato <p-sortIcon field="state_id" /></th>

        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-order>
        <tr (click)="onSelect.emit(order)" class="cursor-pointer">
            <td><b>{{order.code}}</b></td>
            <td>{{order.shortDescription}}</td>
            <td>{{order.clientShortDescription}}</td>
            <td>{{order.reference}}</td>
            <td>{{order.requestDate}}</td>
            <td>{{order.expireDate}}</td>
            <td><p-tag  [value]=" getOrderStatusDescription(order.stateId)" [severity]="getOrderStatusSeverity(order.stateId)"></p-tag></td>


        </tr>
    </ng-template>
</p-table>